export const DEFAULT_EDGE_OPTIONS = { animated: true };
